module.exports = __webpack_public_path__ + "img/pin_blue_medium.faa5d0e3.svg";